import {GetPercentFromXToY} from "js-vextensions";
import React from "react";
import {GetSelectedEngineConfig} from "../../../../../Server/DB/engineConfigs.js";
import {store} from "../../../../../Store/index.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";

const progressBarHeight = 0.01;
const zo = .001;
export const ProgressBar = observer_mgl_r3((props: {texWToHRatio: number})=>{
	const {texWToHRatio} = props;
	const vrState = store.main.tools.vr;
	const config = GetSelectedEngineConfig()?.vr;
	if (config == null) return null;
	if (vrState.imageFrames.length == 0) return null;

	//const timeCredit = GetTimeCredit(config.frames_timeCreditLimitPerFrame * 1000);
	const percentToTimeCreditTarget = (vrState.timeCredit_duringRemoteSession / config.frames_timeCreditTarget).NaNTo(0).KeepAtLeast(0);

	const markerPoints = [] as number[];
	for (let offset = config.frames_timeCreditMarkerInterval; offset < config.frames_timeCreditTarget; offset += config.frames_timeCreditMarkerInterval) {
		const percent = GetPercentFromXToY(0, config.frames_timeCreditTarget, offset);
		markerPoints.push(percent);
	}

	return (
		<>
			{/* Progress bar */}
			<group position={[0, 0.5 + (progressBarHeight / 2), 0]}>
				{/* Background (gray) */}
				<mesh>
					<planeGeometry args={[texWToHRatio, progressBarHeight]}/>
					<meshBasicMaterial color="#555555" transparent opacity={0.3} depthWrite={false}/>
				</mesh>

				{/* Progress part (blue) */}
				<mesh position={[(percentToTimeCreditTarget * texWToHRatio / 2) - (texWToHRatio / 2), 0, zo * 1]} renderOrder={1}>
					<planeGeometry args={[texWToHRatio * percentToTimeCreditTarget, progressBarHeight]}/>
					<meshBasicMaterial color="#0066ff" transparent opacity={0.3} depthWrite={false}/>
				</mesh>
				{markerPoints.map((point, index)=>{
					return <Milestone key={index} {...{textureWidthRelToHeight: texWToHRatio}} point={point} color="#ffffff"/>;
				})}
			</group>
		</>
	);
});

const Milestone = (props: {textureWidthRelToHeight: number, point: number, color: string})=>{
	const {textureWidthRelToHeight, point, color} = props;
	return (
		<mesh position={[(point - 0.5) * textureWidthRelToHeight, 0, zo * 2]} renderOrder={2}>
			<planeGeometry args={[0.005, progressBarHeight]}/>
			<meshBasicMaterial color={color} transparent opacity={0.1} depthWrite={false}/>
		</mesh>
	);
};